import { render, staticRenderFns } from "./list.vue?vue&type=template&id=005a7c7c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=005a7c7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a7c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005a7c7c')) {
      api.createRecord('005a7c7c', component.options)
    } else {
      api.reload('005a7c7c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=005a7c7c&scoped=true", function () {
      api.rerender('005a7c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/knowledge/list.vue"
export default component.exports